import React, { useState } from 'react';

const ContactForm: React.FC = () => {
  const [status, setStatus] = useState<'idle' | 'sending' | 'success' | 'error'>('idle');
  const [requestId, setRequestId] = useState('');

  const ACCESS_KEY = "d851668c-3ff8-432f-b991-3b0653ae3998"; 

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus('sending');

    const formData = new FormData(e.currentTarget);
    formData.append("access_key", ACCESS_KEY);
    formData.append("subject", "Nueva Solicitud Early Adopter - OncoFHIR Prescribe");
    formData.append("from_name", "Portal OncoFHIR Prescribe");

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formData
      });

      const data = await response.json();

      if (data.success) {
        const id = 'REQ-' + Math.random().toString(36).substr(2, 6).toUpperCase();
        setRequestId(id);
        setStatus('success');
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  if (status === 'success') {
    return (
      <section id="contacto" className="py-32 bg-slate-50 text-center scroll-mt-20">
        <div className="max-w-xl mx-auto bg-white p-12 md:p-16 rounded-[3.5rem] shadow-2xl border border-onco/20 animate-in fade-in zoom-in duration-500">
          <div className="w-20 h-20 bg-onco/10 text-onco rounded-full flex items-center justify-center text-4xl mx-auto mb-8">
            <i className="fas fa-check"></i>
          </div>
          
          <h2 className="text-3xl font-black text-dark mb-4 italic">Solicitud Recibida</h2>
          <div className="inline-block bg-slate-100 px-4 py-1.5 rounded-full text-[10px] font-black text-slate-500 tracking-widest uppercase mb-8">
            ID DE SEGUIMIENTO: {requestId}
          </div>

          <p className="text-gray-600 font-medium leading-relaxed mb-8">
            Su interés en el programa Early Adopter de <span className="text-medical font-bold">OncoFHIR Prescribe</span> ha sido registrado exitosamente en nuestros sistemas clínicos.
          </p>

          <div className="bg-medical/5 border border-medical/10 p-8 rounded-3xl text-left">
            <h4 className="text-xs font-black text-medical uppercase tracking-widest mb-4 flex items-center gap-2">
              <i className="fas fa-clock"></i> Compromiso de Respuesta:
            </h4>
            <ul className="space-y-4">
              <li className="flex gap-3">
                <span className="w-5 h-5 bg-medical text-white rounded-full flex items-center justify-center text-[10px] flex-shrink-0 mt-0.5">1</span>
                <p className="text-xs text-gray-500 font-bold leading-tight">
                  Un Consultor Clínico revisará sus datos para validar la compatibilidad de su práctica.
                </p>
              </li>
              <li className="flex gap-3">
                <span className="w-5 h-5 bg-medical text-white rounded-full flex items-center justify-center text-[10px] flex-shrink-0 mt-0.5">2</span>
                <p className="text-xs text-gray-500 font-bold leading-tight">
                  Usted recibirá una llamada o mensaje de WhatsApp en <span className="text-dark">menos de 24 horas hábiles</span> para agendar su sesión de demostración.
                </p>
              </li>
              <li className="flex gap-3">
                <span className="w-5 h-5 bg-fhir text-white rounded-full flex items-center justify-center text-[10px] flex-shrink-0 mt-0.5">!</span>
                <p className="text-xs text-fhir font-black leading-tight italic">
                  Por favor, revise su carpeta de spam/no deseado por si nuestra comunicación inicial es filtrada.
                </p>
              </li>
            </ul>
          </div>

          <button 
            onClick={() => setStatus('idle')}
            className="mt-12 text-gray-400 font-bold text-xs uppercase tracking-[0.2em] hover:text-medical transition-colors"
          >
            ← Volver al formulario
          </button>
        </div>
      </section>
    );
  }

  return (
    <section id="contacto" className="py-32 bg-gradient-to-b from-white to-slate-100 scroll-mt-20 relative z-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mx-auto">
          <div className="bg-white p-10 md:p-14 rounded-[3.5rem] shadow-[0_50px_100px_-20px_rgba(0,0,0,0.12)] border border-slate-100">
            <h3 className="text-3xl font-black text-dark mb-4 italic text-center">Solicitud de Implementación</h3>
            
            <div className="text-center mb-10 space-y-2">
              <p className="text-fhir font-black uppercase tracking-widest text-xs">
                PROGRAMA EARLY ADOPTER 2026
              </p>
              <p className="text-gray-500 font-medium text-sm leading-relaxed max-w-md mx-auto">
                Complete los datos de su práctica. Nos pondremos en contacto con usted en menos de 24 horas hábiles.
              </p>
            </div>
            
            {status === 'error' && (
              <div className="mb-6 p-4 bg-red-50 text-red-600 rounded-xl text-xs font-bold border border-red-100 flex items-center gap-3">
                <i className="fas fa-exclamation-circle"></i>
                Error al procesar. Intente más tarde o contáctenos por canales directos.
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-6">
              <input type="checkbox" name="botcheck" className="hidden" style={{ display: 'none' }} />

              <div>
                <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-2 block ml-1">Práctica Oncológica</label>
                <input 
                  required 
                  name="Clinica_Nombre"
                  type="text" 
                  placeholder="Ej: Clínica de Oncología Avanzada" 
                  className="w-full bg-slate-50 border border-slate-100 px-5 py-4 rounded-2xl text-sm font-bold focus:border-fhir focus:bg-white outline-none transition-all" 
                />
              </div>

              <div className="grid grid-cols-2 gap-6">
                <div>
                  <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-2 block ml-1">País</label>
                  <select name="Pais" className="w-full bg-slate-50 border border-slate-100 px-5 py-4 rounded-2xl text-sm font-bold focus:border-fhir outline-none appearance-none cursor-pointer">
                    <option>Argentina</option>
                    <option>Belice</option>
                    <option>Chile</option>
                    <option>Colombia</option>
                    <option>Costa Rica</option>
                    <option>El Salvador</option>
                    <option>Guatemala</option>
                    <option>Honduras</option>
                    <option>México</option>
                    <option>Nicaragua</option>
                    <option>Panamá</option>
                    <option>Perú</option>
                    <option>República Dominicana</option>
                    <option>Otro</option>
                  </select>
                </div>
                <div>
                  <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-2 block ml-1">Su Rol</label>
                  <select name="Rol_Clinico" className="w-full bg-slate-50 border border-slate-100 px-5 py-4 rounded-2xl text-sm font-bold focus:border-fhir outline-none appearance-none cursor-pointer">
                    <option>Oncólogo(a)</option>
                    <option>Administrador(a)</option>
                    <option>Farmacéutico(a)</option>
                    <option>Enfermería</option>
                  </select>
                </div>
              </div>

              <div>
                <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-2 block ml-1">TELÉFONO (WhatsApp)</label>
                <input 
                  required
                  name="WhatsApp"
                  type="text" 
                  placeholder="+507 6123-4567" 
                  className="w-full bg-slate-50 border border-slate-100 px-5 py-4 rounded-2xl text-sm font-bold focus:border-fhir focus:bg-white outline-none transition-all" 
                />
              </div>

              <div>
                <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-2 block ml-1">Email Profesional</label>
                <input 
                  required 
                  name="email"
                  type="email" 
                  placeholder="doctor@clinica.com" 
                  className="w-full bg-slate-50 border border-slate-100 px-5 py-4 rounded-2xl text-sm font-bold focus:border-fhir outline-none transition-all" 
                />
              </div>

              <div className="pt-4">
                <button 
                  type="submit"
                  disabled={status === 'sending'}
                  className={`w-full ${status === 'sending' ? 'bg-gray-400 cursor-not-allowed' : 'bg-fhir hover:bg-orange-600'} text-white font-black py-6 rounded-2xl shadow-xl shadow-fhir/30 transition-all transform hover:scale-[1.02] active:scale-95 uppercase tracking-widest text-sm flex items-center justify-center gap-3`}
                >
                  {status === 'sending' ? (
                    <>
                      <i className="fas fa-circle-notch animate-spin"></i>
                      Procesando Solicitud...
                    </>
                  ) : (
                    'RESERVAR MI CUPO'
                  )}
                </button>
                
                <div className="mt-8 flex flex-col items-center gap-4 border-t border-slate-100 pt-8">
                  <div className="flex items-center gap-2 text-[10px] text-gray-400 font-bold uppercase tracking-widest">
                    <i className="fas fa-shield-alt text-onco"></i>
                    Sus datos están protegidos y son confidenciales
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;